import React, { useRef, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './rangeFilter.module.scss';
import { useClickOutside, useFixedDropdownPosition } from '../../../utils';
import { Button } from '../..';
import FilterTitle from '../_elements/filterTitle/filterTitle';

const RangeFilter = ({
  title,
  lt,
  setLt,
  gt,
  setGt,
  onSubmit,
  sortOrder,
  setSortOrder,
  name,
  position,
  isActive,
  customWidth,
  disabled,
}) => {
  const filterRef = useRef();
  const dropdownRef = useRef();
  const [isOpen, setIsOpen] = useClickOutside(filterRef);
  const [shouldSort, setShouldSort] = useState(false);
  const dropdownStyle = useFixedDropdownPosition({
    triggerRef: filterRef,
    dropdownRef,
    isOpen,
    position,
  });

  const handleTitleClick = () => {
    if (disabled) {
      return;
    }

    if (!isOpen) {
      setShouldSort(false);
    }
    isOpen ? setIsOpen(false) : setIsOpen(true);
  };

  const handleOrderClick = () => {
    if (disabled) {
      return;
    }

    setShouldSort(true);
    sortOrder === 'asc' ? setSortOrder('desc') : setSortOrder('asc');
  };

  const handleSubmit = () => {
    if (disabled) {
      return;
    }

    setIsOpen(false);
    onSubmit(shouldSort ? { sortBy: name } : {});
  };

  return (
    <div className={styles.container} ref={filterRef}>
      <FilterTitle
        title={title}
        onTitleClick={handleTitleClick}
        isActive={isActive}
        customWidth={customWidth}
        disabled={disabled}
      />

      {isOpen && (
        <div
          ref={dropdownRef}
          className={cn(styles.filter, styles[position])}
          style={dropdownStyle}
        >
          <div className={styles.range}>
            <input
              className={styles.input}
              type="number"
              placeholder="Nuo"
              min="0"
              value={gt}
              disabled={disabled}
              onChange={e => setGt(e.target.value)}
            />
            <input
              className={styles.input}
              type="number"
              placeholder="Iki"
              min="0"
              value={lt}
              disabled={disabled}
              onChange={e => setLt(e.target.value)}
            />
          </div>

          <div className={styles.actions}>
            <Button
              color="light"
              classes={{ button: styles.button }}
              onClick={handleOrderClick}
              disabled={disabled}
            >
              {sortOrder === 'asc' ? 'A-Z' : 'Z-A'}
            </Button>
            <Button
              color="primary"
              classes={{ button: styles.button }}
              onClick={handleSubmit}
              disabled={disabled}
            >
              Filtruoti
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

RangeFilter.defaultProps = {
  position: 'left',
  customWidth: null,
  disabled: false,
};

RangeFilter.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  lt: PropTypes.string.isRequired,
  setLt: PropTypes.func.isRequired,
  gt: PropTypes.string.isRequired,
  setGt: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  sortOrder: PropTypes.oneOf(['asc', 'desc']).isRequired,
  setSortOrder: PropTypes.func.isRequired,
  position: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  customWidth: PropTypes.string,
  disabled: PropTypes.bool,
};

export default RangeFilter;
